import React from 'react'

interface DoubleArrowProps {
  width?: number
  height?: number
  strokeColor?: string
  className?: string
}

const DoubleArrow: React.FC<DoubleArrowProps> = ({
  width = 24,
  height = 24,
  strokeColor = '#000000',
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 64 64"
      fill="none"
      stroke={strokeColor}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <polyline points="16 16 32 32 16 48" />
      <polyline points="32 16 48 32 32 48" />
    </svg>
  )
}

export default DoubleArrow
